@if (enabled) {
    @if (!hideBubble && !_chatState.isChatVisible) {
        <lg-chat-bubble (chatToggled)="_chatToggle()"></lg-chat-bubble>
    }
    @if (_chatState.isChatVisible) {
        <lg-chat-window
            (closed)="_chatToggle()"
            (sendMessage)="_sendMessage($event)"
            [introductionTemplate]="introductionTemplate"
            (prepareMail)="_prepareMail()"
            [chatTitle]="chatTitle"
        ></lg-chat-window>
    }
    <ng-template #introductionTemplate>
        <ng-content select="[introductionTemplate]"></ng-content>
    </ng-template>
}
